import { breakpoints } from './breakpoints';

const FONT_SIZE = 16;

export function remToPx(value: string) {
  return Math.round(parseFloat(value) * FONT_SIZE);
}

export function pxToRem(value: number) {
  return `${value / FONT_SIZE}rem`;
}

export function responsiveFontSizes({ sm }: { sm: number }) {
  return {
    [`@media (max-width:${breakpoints.values.sm}px)`]: {
      fontSize: pxToRem(sm),
    },
  };
}
